import TextInput from "components/TextInput";
import React from "react";
// import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  border: 1px solid #e4e7ed;
  box-sizing: border-box;
  border-radius: 8px;
  min-height: 50px;
  margin-block: 15px;
  padding: 20px;
`;

const Animation = styled.div`
  max-height: ${(props) => (!props.active ? "0px" : "1000px")};
  transition: all 0.5s ease-out;
  overflow: hidden;
`;

const SmsChannel = (props) => {
  const { form, onChange, active, validation } = props;

  return (
    <Animation active={active}>
      <Wrapper>
        <TextInput
          title="Sender’s number"
          value={form.senderNumber}
          placeholder="E.g. 081234567890"
          className="margin-bottom-15 input-auth"
          onChange={(event) => onChange({ ...form, senderNumber: event.target.value })}
          invalidFeedback={validation.senderNumber}
        />
        <TextInput
          title="Sender’s name"
          value={form.senderName}
          invalidFeedback={validation.senderName}
          placeholder="E.g. Omni Communication Assistant"
          className="input-auth"
          onChange={(event) => onChange({ ...form, senderName: event.target.value })}
        />
      </Wrapper>
    </Animation>
  );
};

SmsChannel.propTypes = {};

export default SmsChannel;
